module.exports = __webpack_public_path__ + "static/img/discount.21494968.png";